import * as Yup from "yup";

const PHONE_NUMBER_VALIDATION = new RegExp(
  /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/
);

export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email")
    .required("Please enter email address"),
  telephone: Yup.string()
    .transform((value) => {
      return value ? value.replace(/\s+/g, "") : value;
    })
    .required("Please enter phone number")
    .max(14, "Please enter a valid phone number")
    .matches(PHONE_NUMBER_VALIDATION, "Please enter a valid phone number"),
  forename: Yup.string().required("Please enter first name"),
  surname: Yup.string().required("Please enter surname"),
  notes: Yup.string(),
});
